import { Type, User } from '../network/types';
import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';

const SUPPORTED_RETAIL_UNITS = ['my'];

export function setInsiderObject(user: User) {
  const { retailUnit } = getRetailUnitAndLanguage();

  if (user.type === Type.GUEST || !SUPPORTED_RETAIL_UNITS.includes(retailUnit)) return;

  if (!user.custom.emailAddress || !user.custom.userId) throw new Error('Email or userId not found');

  globalThis.insider_object = globalThis.insider_object ?? {};

  globalThis.insider_object.user = {
    email: user.custom.emailAddress,
    custom_identifiers: {
      userid: user.custom.userId,
    },
  };
}
